import cn from 'clsx';
import { ArrowButton } from "../shared/components";
import SplitImage from "../shared/components/SplitImage";
import { BadgeDiamond, PlayroomBadgeCardCompleted, PlayroomBadgeCardDescription, PlayroomBadgeCardTag } from "./components";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var PlayroomBadgeCard = function PlayroomBadgeCard(_ref) {
  var badgeTagLabel = _ref.badgeTagLabel,
    badgeTagColor = _ref.badgeTagColor,
    coins = _ref.coins,
    badgeTitle = _ref.badgeTitle,
    _ref$completed = _ref.completed,
    completed = _ref$completed === void 0 ? false : _ref$completed,
    animations = _ref.animations,
    onClickCTA = _ref.onClickCTA,
    ctaLabel = _ref.ctaLabel,
    achievementLogoSrc = _ref.achievementLogoSrc,
    className = _ref.className,
    style = _ref.style,
    achievementId = _ref.achievementId,
    subjectName = _ref.subjectName,
    dataTestIid = _ref['data-testid'],
    role = _ref.role;
  if (completed) {
    return /*#__PURE__*/_jsx(PlayroomBadgeCardCompleted, {
      achievementId: achievementId,
      coins: coins,
      badgeTitle: badgeTitle,
      badgeTagLabel: badgeTagLabel,
      badgeTagColor: badgeTagColor,
      subjectName: subjectName,
      className: className
    });
  }
  return /*#__PURE__*/_jsxs("article", {
    className: cn(
    // Common styles
    // * tw-relative: used to fix overflow hidden on Safari
    'tw-relative dark:tw-text-primary-light-100 tw-rounded-2.4 tw-overflow-hidden',
    // Shadow
    'hover:tw-shadow-02 hover:dark:tw-shadow-neutral-dark-700 tw-transition-shadow',
    // Backgrounds
    'tw-bg-neutral-light-100 dark:tw-bg-neutral-dark-700',
    // Borders
    'tw-border tw-border-solid tw-border-neutral-light-400 dark:tw-border-neutral-dark-500',
    // Heights
    'tw-h-24 tw-min-h-24',
    // Flex
    'tw-flex tw-flex-col tw-justify-between', className),
    role: role,
    style: style,
    "data-testid": dataTestIid,
    children: [/*#__PURE__*/_jsxs("header", {
      className: "tw-relative tw-h-8.8 tw-bg-neutral-light-200 dark:tw-bg-neutral-dark-500",
      children: [!!coins && /*#__PURE__*/_jsx(BadgeDiamond, {
        diamonds: coins,
        animations: animations
      }), /*#__PURE__*/_jsx(SplitImage, {
        src: achievementLogoSrc,
        className: "tw-mx-auto tw-mt-3.6",
        title: badgeTitle,
        size: 80
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: "tw-p-2.4",
      children: [!!badgeTagLabel && /*#__PURE__*/_jsx(PlayroomBadgeCardTag, {
        label: badgeTagLabel,
        noColor: true
      }), /*#__PURE__*/_jsx(PlayroomBadgeCardDescription, {
        text: badgeTitle
      }), !!ctaLabel && /*#__PURE__*/_jsx(ArrowButton, {
        label: ctaLabel,
        onClick: onClickCTA,
        className: "tw-btn-icon"
      })]
    })]
  });
};
export default PlayroomBadgeCard;